import { useEffect, useRef, useState } from 'react';

function QRModal({ url, onClose }) {
  const containerRef = useRef(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!containerRef.current) return;
    containerRef.current.innerHTML = '';
    if (window.QRCode) {
      new window.QRCode(containerRef.current, {
        text: url,
        width: 220,
        height: 220,
        colorDark: '#181614',
        colorLight: '#ffffff',
        correctLevel: window.QRCode.CorrectLevel.M,
      });
    } else {
      containerRef.current.innerHTML = '<div style="color:#B5AA9A;font-size:13px;padding:20px">Libreria QR non disponibile</div>';
    }
  }, [url]);

  const handleCopy = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div>
      <div style={{display:'flex',justifyContent:'center',marginBottom:16}}>
        <div ref={containerRef} style={{
          background:'#fff',padding:12,borderRadius:12,
          border:'1px solid rgba(237,77,29,0.1)',
          display:'inline-block',
        }}/>
      </div>
      <div style={{
        fontSize:16,color:'var(--muted2)',textAlign:'center',
        wordBreak:'break-all',marginBottom:16,lineHeight:1.5,
        padding:'0 8px',
      }}>{url}</div>
      <div style={{display:'flex',gap:8}}>
        <button className="btn btn-secondary" style={{flex:1,justifyContent:'center'}} onClick={handleCopy}>
          {copied ? 'Copiato!' : 'Copia link'}
        </button>
        <button className="btn btn-teal" style={{flex:1,justifyContent:'center'}}
          onClick={()=>{ const wa=`https://wa.me/?text=${encodeURIComponent('Segui la serata live: '+url)}`; window.open(wa,'_blank'); }}>
          WhatsApp
        </button>
      </div>
    </div>
  );
}

export default QRModal;
